module.exports = __webpack_public_path__ + "img/water_color.d0f73ed8.svg";